export var getIsActiveOption = function getIsActiveOption(_ref) {
  var option = _ref.option,
    activeOption = _ref.activeOption;
  var result = false;
  if (Array.isArray(activeOption)) {
    for (var i = 0; i < activeOption.length; i += 1) {
      if (!result) {
        result = activeOption[i].id === option.id;
      }
      if (result) {
        break;
      }
    }
  } else {
    var activeId = activeOption.id;
    result = option.id === activeId;
  }
  return result;
};